import axios from 'axios'

import { getUser } from '@/services/auth/user'

const url = process.env.VUE_APP_API_URL

/**
 * Signs in from the one-time ticket the onboarding wizard hands over, so a customer who just
 * created their account does not land on a login form asking for the password they set a minute
 * ago.
 *
 * Plain axios rather than the shared instance: this runs before any session exists, and the shared
 * instance's interceptors would attach a stale Authorization header from a previous user.
 *
 * No refresh token comes back — this is a one-shot session. When the access token runs out the
 * customer signs in normally, which the existing refresh flow already handles by sending them to
 * /login.
 */
export const autoLogin = async (token) => {
  if (!token) return false

  try {
    const { data } = await axios.post(`${url}/web/open/onboarding/login-token/exchange`, { token })
    const accessToken = data?.access_token
    if (!accessToken) return false

    const jwt = JSON.parse(window.atob(accessToken.split('.')[1]))

    localStorage.setItem('access_token', accessToken)
    localStorage.setItem('access_roles', jwt?.authorities)
    localStorage.setItem('timezone', jwt?.timezone)
    localStorage.setItem('currency', jwt?.currency)
    localStorage.setItem('language', jwt?.language)
    localStorage.setItem('user_type', jwt?.userType)
    document.cookie = `access_token=${accessToken}`
    document.cookie = `access_roles=${jwt?.authorities}`

    await getUser()
    return true
  } catch (error) {
    // Nothing is logged: the ticket is a bearer credential and the failure is expected whenever a
    // link is reused or opened late. The caller sends the customer to /login.
    return false
  }
}
